import { blobticService } from '../../Commun/services/blobticService';

export interface Estimate {
    id: number;
    uid: string;
    projectId: number;
    estimateNumber: string;
    estimateDate: Date;
    validUntilDate?: Date;
    subTotal: number;
    taxAmount: number;
    totalAmount: number;
    status: string;
    notes?: string;
    lastUpdate?: Date;
    userId?: number;
}

interface EstimateDto {
    EST_IDF: number;
    EST_UIDF: string;
    EST_CODE: string;
    EST_LIB?: string;
    EST_DESCRIPTION?: string;
    PRJ_IDF: number;
    EST_DATE: string;
    EST_VALID_DATE?: string; // Correctly map from backend
    EST_VALIDITY_DATE?: string; // Or EST_VALIDITY_DATE 
    EST_SUBTOTAL: number;
    EST_TAX_AMOUNT: number;
    EST_AMOUNT: number;
    EST_STATUS: string;
    // EST_NOTES?: string; // Likely EST_DESCRIPTION
    LAST_UPDT?: string;
    USER_IDF?: number;
}

const mapDtoToModel = (dto: EstimateDto): Estimate => ({
    id: dto.EST_IDF,
    uid: dto.EST_UIDF,
    projectId: dto.PRJ_IDF,
    estimateNumber: dto.EST_CODE,
    estimateDate: new Date(dto.EST_DATE),
    validUntilDate: dto.EST_VALIDITY_DATE ? new Date(dto.EST_VALIDITY_DATE) : undefined,
    subTotal: dto.EST_SUBTOTAL,
    taxAmount: dto.EST_TAX_AMOUNT,
    totalAmount: dto.EST_AMOUNT,
    status: dto.EST_STATUS,
    notes: dto.EST_DESCRIPTION,
    lastUpdate: dto.LAST_UPDT ? new Date(dto.LAST_UPDT) : undefined,
    userId: dto.USER_IDF
});

export const estimatesApi = {
    getAll: async () => {
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Maker',
            Action: {
                OKey: 'Blobtic_Maker,maker_estimate,Select'
            }
        });
        if (response.success && Array.isArray(response.data)) {
            return {
                data: response.data.map((item: any) => mapDtoToModel(item)),
                success: true
            };
        }
        return { data: [], success: false, message: response.message };
    },

    getByProject: async (projectId: number) => {
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Maker',
            Action: {
                OKey: 'Blobtic_Maker,maker_estimate,Select',
                PRJ_IDF: projectId
            }
        });
        if (response.success && Array.isArray(response.data)) {
            return {
                data: response.data.map((item: any) => mapDtoToModel(item)),
                success: true
            };
        }
        return { data: [], success: false, message: response.message };
    },

    generate: async (projectId: number, subTotal: number = 0, taxRate: number = 0) => {
        // This likely corresponds to a specific logic in backend to create estimate from project data
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Maker',
            Action: {
                OKey: 'Blobtic_Maker,maker_estimate,Generate',
                PRJ_IDF: projectId,
                EST_SUBTOTAL: subTotal,
                EST_TAX_RATE: taxRate,
                EST_TAX_AMOUNT: subTotal * (taxRate / 100),
                EST_AMOUNT: subTotal * (1 + taxRate / 100)
            }
        });
        return {
            success: response.success,
            message: response.message,
            data: response.data
        };
    }
};
